import { API } from 'api/config'
import { ForgotPasswordResponse } from 'interfaces'
import { captureErrorSentry, SentryEvents, SentrySections } from 'utils'

export const getMyForgotPassword = async (
	email: string
): Promise<ForgotPasswordResponse | null> => {
	let res = null as ForgotPasswordResponse | null
	await API()
		.get(
			`/send_email/forget_password?community_id=${
				process.env.REACT_APP_COMMUNITY_ID
			}&email=${encodeURIComponent(email)}&from_admin=${true}`
		)
		.then(async response => {
			res = response.data
		})
		.catch(error => {
			captureErrorSentry({
				section: SentrySections.AUTHENTICATION,
				event: SentryEvents.FORGOT_PASSWORD_ERROR,
				error,
				extra: {
					params: { email, from_admin: true }
				}
			})
			res = { detail: error.response.data.detail }
		})
	return res
}
